function isAxiosError(error) {
  return error !== null && typeof error === "object" && "isAxiosError" in error && error.isAxiosError;
}
function getHasMessage(data) {
  return "message" in data;
}
function isAxiosErrorWithErrorMessage(error) {
  if (isAxiosError(error)) {
    const hasMessage = error.response !== void 0 && "data" in error.response && typeof error.response.data === "object" && error.response.data !== null && getHasMessage(error.response.data);
    return hasMessage;
  }
  return false;
}
function isAxiosErrorWithBlob(error) {
  if (isAxiosErrorWithResponse(error)) {
    return error.response.data instanceof Blob;
  }
  return false;
}
async function getErrorMessageFromBlobResponse(error) {
  const responseData = JSON.parse(await error.response.data.text());
  if (getHasMessage(responseData)) {
    return responseData.message;
  }
  return void 0;
}
async function getErrorCodeFromBlobResponse(error) {
  const responseData = JSON.parse(await error.response.data.text());
  if ("code" in responseData) {
    return responseData.code;
  }
  return void 0;
}
function isAxiosErrorWithErrorCode(error) {
  if (isAxiosError(error)) {
    const hasCode = error.response !== void 0 && "data" in error.response && typeof error.response.data === "object" && error.response.data !== null && "code" in error.response.data;
    return hasCode;
  }
  return false;
}
function isAxiosErrorWithViolations(error) {
  if (!isAxiosError(error)) {
    return false;
  }
  if (!isAxiosErrorWithResponse(error)) {
    return false;
  }
  if (typeof error.response.data !== "object" || error.response.data === null) {
    return false;
  }
  const hasViolations = "violations" in error.response.data && Array.isArray(error.response.data.violations);
  return hasViolations;
}
function isAxiosErrorWithResponse(error) {
  if (isAxiosError(error)) {
    return error.response !== void 0;
  }
  return false;
}

export { getErrorCodeFromBlobResponse, getErrorMessageFromBlobResponse, getHasMessage, isAxiosError, isAxiosErrorWithBlob, isAxiosErrorWithErrorCode, isAxiosErrorWithErrorMessage, isAxiosErrorWithResponse, isAxiosErrorWithViolations };
//# sourceMappingURL=axiosError.mjs.map
